/**
 * Blueprint for the campaign entity.
 */
export class Campaign {
  public apiKey?: string;
  public listId?: string;
  public clientId?: string;
  public clientSecret?: string;
  public groupId?: number;

  public constructor(campaign?: any) {
    this.clientId = campaign?.clientId;
    this.apiKey = campaign?.apiKey;
    this.clientSecret = campaign?.clientSecret;
    this.groupId = campaign?.groupId;
  }
}
